export default "__VITE_ASSET__Ts5xjZoa__"